var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nws_overview"},[_c('h1',[_vm._v(_vm._s(_vm.$t('system.nws')))]),_c('BCDList',{attrs:{"bcds":_vm.bcds,"bcd2subnets":_vm.bcd2subnets,"bcd2vlans":_vm.bcd2vlans,"ous":_vm.ous,"bcd2ous":_vm.bcd2ous,"default_sort_by":'name',"bcd2vnis":_vm.bcd2vnis,"show_usage":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }